"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseFileIMSchema = exports.LicenseFileSchema = exports.BaseLicenseFileSchema = void 0;
const zod_1 = require("zod");
const storage_object_1 = require("./storage-object");
const license_schema_1 = require("./license-schema");
const license_enums_1 = require("../enums/license-enums");
exports.BaseLicenseFileSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: license_enums_1.LicenseFileTypeSchema,
    licenseId: zod_1.z.string(),
    storageObjectVersionId: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
});
exports.LicenseFileSchema = zod_1.z.lazy(() => exports.BaseLicenseFileSchema.extend({
    license: zod_1.z.lazy(() => license_schema_1.BaseLicenseSchema),
    storageObjectVersion: zod_1.z.lazy(() => storage_object_1.StorageObjectVersionBaseSchema),
}));
exports.LicenseFileIMSchema = zod_1.z.lazy(() => exports.BaseLicenseFileSchema.omit({
    id: true,
    updatedAt: true,
    createdAt: true,
}));
